<app-loader></app-loader>

<!-- Mobile Header -->
<header
  *ngIf="isScreenWidthLessThan800() && !isTreasurePickRoute()"
  class="mobile-header sticky z-[997] w-full top-0"
>
  <div class="mobile-header-inner">
    <button
      class="mobile-menu-btn"
      (click)="toggleSidebar($event)"
      aria-label="Menu"
    >
      <svg
        class="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M4 6h16M4 12h16M4 18h16"
        />
      </svg>
    </button>

    <a
      class="mobile-logo-link"
      [routerLink]="isDashboardRoute() ? '/dashboard/home' : '/'"
    >
      <img
        src="Logo/logo-opt.webp"
        alt="Rush Plays Logo"
        class="mobile-logo-img"
      />
    </a>

    <button *ngIf="!isLoggedIn" class="join-now-btn" (click)="openJoinNow()">
      Join Now
    </button>
    <div *ngIf="isLoggedIn" class="mobile-header-spacer"></div>
  </div>
</header>

<!-- Desktop Header -->
<header
  *ngIf="!isScreenWidthLessThan800() && !isTreasurePickRoute()"
  class="desktop-header sticky z-[999] w-full top-0"
>
  <div *ngIf="isDashboardRoute() && isLoggedIn" class="header-bg">
    <div class="desktop-header-inner">
      <a class="logo-link">
        <div class="logo-img-wrap flex-shrink-0 flex items-center justify-center">
          <img
            src="Logo/logo-opt.webp"
            alt="Rush Plays Logo"
            class="brand__logo-img"
          />
        </div>
      </a>

      <div class="desktop-actions">
        <button class="deposit-btn" (click)="openWalletModal()">
          <span class="deposit-plus"
            ><svg
              class="w-3.5 h-3.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              stroke-width="2.5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 4v16m8-8H4"
              ></path></svg
          ></span>
          DEPOSIT
        </button>

        <div class="balance-pill wallet-pill" (click)="RedirectToWallet()">
          <span class="balance-label">WALLET</span>
          <span class="balance-currency">$</span>
          <span class="balance-amount">{{
            walletAmount | number: "1.2-2"
          }}</span>
          <span class="status-dot dot-gold"></span>
        </div>

        <button class="icon-btn-desktop" (click)="toggleNotifications()">
          <svg
            class="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
            ></path>
          </svg>
          <span *ngIf="notificationCount" class="notification-badge-desktop">{{
            notificationCount >= 10 ? "9+" : notificationCount
          }}</span>
        </button>

        <div class="avatar-section">
          <button class="avatar-btn-desktop">
            <img [src]="profileImage" alt="Profile" class="avatar-img-desktop" />
          </button>
        </div>

        <div *ngIf="isDropdownOpen" class="dropdown-menu-desktop">
          <div class="dropdown-header">
            <img [src]="profileImage" alt="Profile" class="dropdown-avatar" />
            <span class="dropdown-username" [title]="username"
              >{{ username | slice: 0 : 12
              }}<span *ngIf="(username || '').length > 12">..</span></span
            >
          </div>
          <div class="dropdown-divider"></div>
          <div class="dropdown-items">
            <span class="dropdown-item" (click)="saveUserProfileImage()"
              >Upload Photo</span
            >
            <span class="dropdown-item" (click)="deleteUserProfileImage()"
              >Remove Photo</span
            >
            <span class="dropdown-item" (click)="redirecttochngPass()"
              >Update Password</span
            >
            <span class="dropdown-item" (click)="redirecttoTermsConditions()"
              >Terms & Conditions</span
            >
            <span class="dropdown-item" (click)="redirectToKYCform()"
              >KYC Verification</span
            >
          </div>
          <div class="dropdown-divider"></div>
          <div class="dropdown-items">
            <span class="dropdown-item logout" (click)="showLogoutModal()"
              >Logout</span
            >
          </div>
        </div>

        <app-logoutmodel
          [isOpen]="isLogoutModalOpen"
          [profileImage]="profileImage"
          (onCancel)="closeLogoutModal()"
          (onConfirm)="logout()"
        ></app-logoutmodel>
        <app-deleteaccountmodel
          [isOpen]="isdeleteaccountmodelopen"
          [profileImage]="profileImage"
          (onCancel)="closedeleteaccountmodal()"
          (onConfirm)="deleteaccount($event)"
        ></app-deleteaccountmodel>
      </div>
    </div>
  </div>

  <!-- Guest / logged-out header (Privacy, Terms, etc.) -->
  <div *ngIf="!isDashboardRoute() || !isLoggedIn" class="header-bg">
    <div class="desktop-header-inner">
      <a class="logo-link" routerLink="/">
        <div class="logo-img-wrap flex-shrink-0 flex items-center justify-center">
          <img src="Logo/logo-opt.webp" alt="Casinoze Logo" class="brand__logo-img" />
        </div>
      </a>

      <div class="flex items-center gap-3">
        <button (click)="toggleMusic()"
          class="text-[#94a3b8] hover:text-[#f5cf6b] transition duration-200 focus:outline-none flex items-center justify-center"
          aria-label="Toggle Music">
          <svg *ngIf="!isMuted" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
          </svg>
          <svg *ngIf="isMuted" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" />
          </svg>
        </button>
        <button (click)="redirectToLogin()"
          class="bg-transparent border-none text-[#cbd5e1] text-[12px] font-bold uppercase tracking-[1.2px] hover:text-[#f5cf6b] transition duration-200 focus:outline-none whitespace-nowrap">
          Sign In
        </button>
        <button (click)="openJoinNow()"
          class="bg-[linear-gradient(#f5cf6b,#c8901a)] text-[#2e2206] font-black text-[12px] uppercase tracking-[1.2px] px-5 py-2.5 rounded-[12px] shadow-[0_10px_15px_-3px_rgba(231,181,63,0.2),0_4px_6px_-4px_rgba(231,181,63,0.2)] hover:brightness-110 transition duration-300 focus:outline-none whitespace-nowrap">
          Sign Up
        </button>
      </div>
    </div>
  </div>
</header>

<div *ngIf="isShowBanner()" class="text-center">
  <div class="scroll-container p-2 shadow-2xl rounded-md">
    <div
      class="scroll-content flex w-full justify-center items-center space-x-4 font-semibold"
    >
      <div>🚀💎 WE ACCEPT PAYMENTS VIA:</div>
      <div class="payment-method flex justify-center items-center gap-2">
        <span class="text-white"> CRYPTO</span>💰 |
      </div>
      <div class="payment-method flex justify-center items-center gap-2">
        <span class="text-white">CASH APP</span>💵 |
      </div>
      <div class="payment-method flex justify-center items-center gap-2">
        <span class="text-white">CHIME</span>💵 |
      </div>
      <div class="payment-method flex justify-center items-center gap-2">
        <span class="text-white">PAYPAL</span>💵 |
      </div>
      <div class="payment-method flex justify-center items-center gap-2">
        <span class="text-white">CARD PAYMENT</span>💳✨
      </div>
    </div>
  </div>
</div>

<app-notifications
  *ngIf="showNotifications"
  [notifications]="notifications"
  (closeNotification)="showNotifications = false"
  (notificationsCount)="receiveNotificationCount($event)"
  (openChat)="handleOpenChat()"
></app-notifications>

<app-kyc-popup *ngIf="showKycPopup" (close)="closeKycPopup()"></app-kyc-popup>

<div class="modal-overlay z-[999]" *ngIf="showRefralModal">
  <div class="modal-gradient-wrapper">
    <div class="modal-card" (click)="$event.stopPropagation()">
      <button class="close-btn" (click)="closeReferal()">✕</button>
      <h2 class="title"><span class="text-yellow-400">Referral</span> Bonus</h2>
      <div class="link-wrapper">
        <input type="text" [value]="referralLink" readonly />
        <button class="btn-new copy-btn-wrapper" (click)="copyToClipboard()">
          <div class="btn-new-inner">{{ buttonText }}</div>
        </button>
      </div>
      <div class="rules-box">
        <h3><span class="text-yellow-400">Referral</span> Bonus Rules:</h3>
        <p class="subtitle">
          Earn on Their First
          <span class="text-yellow-400">{{ refCount }} Deposits!</span>
        </p>
        <div class="steps-container">
          <div class="step">
            <span class="step-number">1</span>
            <p>Refer a friend via your link.</p>
          </div>
          <div class="step">
            <span class="step-number">2</span>
            <p>
              Get
              <span class="text-yellow-400">{{ refPercentage }}% Bonus</span> of
              First
              <span class="text-yellow-400">{{ refCount }} Deposit</span> of
              your Friend.
            </p>
          </div>
        </div>
      </div>
      <button class="btn-new cta-btn-wrapper" (click)="gotoreflist()">
        <div class="btn-new-inner">View Referrals</div>
      </button>
    </div>
  </div>
</div>
